"use client"

import { useState } from "react"
import { Container, Row, Col, Modal, Button } from "react-bootstrap"
import { FaArrowUp, FaTimes, FaAward, FaCheckCircle, } from "react-icons/fa"
import { motion } from "framer-motion"
import { HashLink } from 'react-router-hash-link'
import { useNavigate } from 'react-router-dom'
import bgImage from "../assets/images/Reactiva.png"
import "./Footer.css"

const Footer = () => {
  const currentYear = new Date().getFullYear()
  const [showQualityModal, setShowQualityModal] = useState(false)

  const navigate = useNavigate()

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" })
  }

  const handleShowQualityModal = (e) => {
    e.preventDefault()
    setShowQualityModal(true)
  }

  const handleCloseQualityModal = () => {
    setShowQualityModal(false)
  }



 
  const handleNavigation = (path) => {
    // Si ya estamos en la página principal, hacer scroll
    if (window.location.pathname === '/') {
      const element = document.querySelector(path)
      if (element) {
        const yOffset = -80
        const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset
        window.scrollTo({ top: y, behavior: 'smooth' })
      }
    } else {
      // Si no estamos en la página principal, navegar a ella con el hash
      navigate(`/${path}`)
    }
  }

  return (
    <>
      <footer className="distinctive-footer">
        {/* Patrón geométrico de fondo */}
        <div className="footer-geometric-pattern">
          <div className="geometric-grid">
            {[...Array(20)].map((_, i) => (
              <div key={i} className={`geometric-element geo-${(i % 4) + 1}`} />
            ))}
          </div>
          <div className="footer-wave-top"></div>
        </div>

        <Container>
          {/* Sección principal del footer */}
          <div className="footer-main-section">
            <Row className="footer-primary-row">
              {/* Columna de la marca */}
              <Col lg={3} md={6} className="mb-5">
                <motion.div
                  initial={{ opacity: 0, x: -30 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6 }}
                  className="footer-brand-column"
                >
                  <div className="footer-logo-section">
                    <div className="logo-wrapper">
                      <HashLink 
                        to="/#home" 
                        style={{ textDecoration: 'none', display: 'inline-block' }}
                        scroll={(el) => {
                          const yOffset = -80;
                          const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
                          window.scrollTo({ top: y, behavior: 'smooth' });
                        }}
                      >
                        <img src={bgImage || "/placeholder.svg"} alt="Reactiva Logo" className="footer-brand-logo" />
                      </HashLink>
                    </div>
                    <h4 className="footer-brand-name">Reactiva S.A.S</h4>
                  </div>
                  <p className="footer-brand-description">
                    Soluciones tecnológicas innovadoras para impulsar tu negocio en la era digital. Transformamos ideas
                    en realidades digitales con más de 20 años de experiencia.
                  </p>
                </motion.div>
              </Col>

              {/* Columna de navegación - desplazada a la derecha con offset */}
              <Col lg={{ span: 5, offset: 4 }} md={12} className="mb-5">
                <motion.div
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, delay: 0.2 }}
                  className="footer-nav-column"
                >
                  <h5 className="footer-column-title">
                    <span className="title-icon">🔗</span>
                    Enlaces Rápidos
                  </h5>
                  <nav className="footer-navigation">
                    <a 
                      href="#home" 
                      className="nav-item-footer"
                      onClick={(e) => {
                        e.preventDefault();
                        handleNavigation('#home');
                      }}
                    >
                      <span className="nav-bullet">▶</span>
                      Inicio
                    </a>
                    <a 
                      href="#about" 
                      className="nav-item-footer"
                      onClick={(e) => {
                        e.preventDefault();
                        handleNavigation('#about');
                      }}
                    >
                      <span className="nav-bullet">▶</span>
                      Nosotros
                    </a>
                    <a 
                      href="#services" 
                      className="nav-item-footer"
                      onClick={(e) => {
                        e.preventDefault();
                        handleNavigation('#services');
                      }}
                    >
                      <span className="nav-bullet">▶</span>
                      Proyectos
                    </a>
                    <a 
                      href="#team" 
                      className="nav-item-footer"
                      onClick={(e) => {
                        e.preventDefault();
                        handleNavigation('#team');
                      }}
                    >
                      <span className="nav-bullet">▶</span>
                      Marcas Aliadas
                    </a>
                    <a 
                      href="#" 
                      onClick={handleShowQualityModal} 
                      className="nav-item-footer quality-link"
                    >
                      <span className="nav-bullet">▶</span>
                      Políticas de Calidad
                    </a>
                    {/* Nuevo botón de Tratamiento de Datos Personales */}
                    <a 
                      href="#" 
                      className="nav-item-footer privacy-link"
                      onClick={(e) => {
                        e.preventDefault();
                        navigate('/tratamiento-datos');
                      }}
                    >
                      <span className="nav-bullet">▶</span>
                      Tratamiento de Datos Personales y Privacidad
                    </a>
                  </nav>
                </motion.div>
              </Col>
            </Row>
          </div>

          {/* Separador distintivo */}
          <div className="footer-separator">
            <div className="separator-line"></div>
            <div className="separator-diamond">
              <div className="diamond-inner"></div>
            </div>
            <div className="separator-line"></div>
          </div>

          {/* Footer bottom */}
          <div className="footer-bottom-section">
            <Row className="justify-content-center">
              <Col xs={12} md={8} className="text-center">
                <p className="copyright-text">
                  <strong>&copy; {currentYear} Reactiva Soporte y Desarrollo S.A.S</strong>
                  <span className="copyright-separator"> | </span>
                  Todos los derechos reservados
                </p>
              </Col>
            </Row>
          </div>
        </Container>

        {/* Botón scroll to top distintivo */}
        <motion.button
          className="scroll-top-button"
          onClick={scrollToTop}
          initial={{ opacity: 0, scale: 0 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.8 }}
          whileHover={{ scale: 1.1, rotate: 360 }}
          whileTap={{ scale: 0.9 }}
        >
          <FaArrowUp />
        </motion.button>
      </footer>

      {/* Modal de Políticas de Calidad */}
      <Modal
        show={showQualityModal}
        onHide={handleCloseQualityModal}
        size="lg"
        centered
        className="quality-modal"
        backdrop="static"
      >
        <Modal.Header className="quality-modal-header">
          <div className="modal-header-content">
            <div className="modal-icon">
              <FaAward />
            </div>
            <div className="modal-title-section">
              <Modal.Title className="quality-modal-title">Políticas de Calidad</Modal.Title>
              <p className="quality-modal-subtitle">Reactiva S.A.S - Compromiso con la Excelencia</p>
            </div>
          </div>
          <Button variant="link" className="modal-close-btn" onClick={handleCloseQualityModal}>
            <FaTimes style={{ fontSize: '30px' }} />
          </Button>
        </Modal.Header>

        <Modal.Body className="quality-modal-body">
          <div className="quality-content">
            {/* Introducción */}
            <div className="quality-section">
              <h5 className="section-title">
                <FaCheckCircle className="section-icon" />
                Nuestro Compromiso
              </h5>
              <p className="section-text">
                En Reactiva Soporte y desarrollo S.A.S. tenemos como política de calidad ir más allá de los requerimientos del cliente para entregar una solución  tecnológica.
              </p>
              <br></br>
              <p className="section-text">
                Garantizando el cumplimiento de los requisitos legales, de clientes y de la norma ISO 9001:2015 buscando la eficacia en los procesos a través de la optimización de recursos y la mejora continua.
              </p>
            </div>

            {/* Principios de Calidad */}
            <div className="quality-section">
              <h5 className="section-title">
                <FaCheckCircle className="section-icon" />
                Principios de Calidad
              </h5>
              <div className="quality-principles">
                <div className="principle-item">
                  <div className="principle-number">01</div>
                  <div className="principle-content">
                    <h6>Excelencia Técnica</h6>
                    <p>Utilizamos las mejores prácticas y tecnologías más avanzadas del mercado.</p>
                  </div>
                </div>
                <div className="principle-item">
                  <div className="principle-number">02</div>
                  <div className="principle-content">
                    <h6>Mejora Continua</h6>
                    <p>Evaluamos y mejoramos constantemente nuestros procesos y servicios.</p>
                  </div>
                </div>
                <div className="principle-item">
                  <div className="principle-number">03</div>
                  <div className="principle-content">
                    <h6>Satisfacción del Cliente</h6>
                    <p>Priorizamos las necesidades y expectativas de nuestros clientes en cada proyecto.</p>
                  </div>
                </div>
                <div className="principle-item">
                  <div className="principle-number">04</div>
                  <div className="principle-content">
                    <h6>Innovación Constante</h6>
                    <p>Incorporamos las últimas tendencias tecnológicas en nuestras soluciones.</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Estándares */}
            <div className="quality-section">
              <h5 className="section-title">
                <FaCheckCircle className="section-icon" />
                Estándares de Calidad
              </h5>
              <div className="standards-grid">
                <div className="standard-card">
                  <h6>Desarrollo de Software</h6>
                  <ul>
                    <li>Metodologías ágiles (Scrum, Kanban)</li>
                    <li>Testing automatizado</li>
                    <li>Code review obligatorio</li>
                    <li>Documentación completa</li>
                  </ul>
                </div>
                <div className="standard-card">
                  <h6>Gestión de Proyectos</h6>
                  <ul>
                    <li>Planificación detallada</li>
                    <li>Comunicación transparente</li>
                    <li>Seguimiento continuo</li>
                    <li>Entrega puntual</li>
                  </ul>
                </div>
                <div className="standard-card">
                  <h6>Soporte Técnico</h6>
                  <ul>
                    <li>Respuesta en menos de 24 horas</li>
                    <li>Soporte multicanal</li>
                    <li>Documentación actualizada</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer className="quality-modal-footer">
          <div className="footer-info" >
            <p >
              <strong>&copy; {currentYear} Reactiva Soporte y Desarrollo S.A.S</strong>
            </p>
          </div>
        </Modal.Footer>
      </Modal>

      {/* Modal de Tratamiento de Datos Personales y Privacidad */}
      
    </>
  )
}

export default Footer